import { CsatResultAttributes } from "services/csat/types";
import { CsatResult } from "services/csat";
import RecordClassCreator, {
  ManyResourcePayload,
  RecordAttributeMapper,
  SingleResource, SingleResourcePayload
} from "services/record";

interface ConversationAttributes {
  created: number;
  csat: CsatResult;
}

export default class Conversation extends RecordClassCreator<ConversationAttributes>({
  type: "conversation",
  created: null,
  csat: null
}) {
  static attributeMapper: RecordAttributeMapper<ConversationAttributes> = {
    csat: (value: CsatResultAttributes) => value && new CsatResult(value)
  };

  static resolveFetchOneResult(payload: {
    conversation: ConversationAttributes & { _id: string; _type: string };
  }): SingleResourcePayload {
    return {
      ...payload,
      data: {
        ...payload.conversation
      }
    };
  }

  static resolveFetchManyResult(payload: {conversations: SingleResource[]}): ManyResourcePayload {
    return {
      ...payload,
      data: payload.conversations,
      included: []
    };
  }
}
